import {Component, ElementRef, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, switchMap} from 'rxjs/operators';
import {ArticleService} from '../../services/article.service';
import {ArticlesSearch} from '../../entities/ArticlesSearch';
import {Router} from '@angular/router';
import { UserService } from 'src/app/modules/auth-client/services/user.service';
import {ShoppingService} from '../../services/shopping.service';
import {CompanyService} from '../../services/company.service';

@Component({
    selector: 'brover-quick-order',
    styleUrls: ['./quick-order.component.sass'],
    templateUrl: './quick-order.component.html',
    standalone: false
})
export class QuickOrderComponent {
  @ViewChild('file') fileInput: ElementRef;

  brands: any[] = [];

  constructor(private articleService: ArticleService, private router: Router, private userService: UserService,
              public shoppingService: ShoppingService, public companyService: CompanyService) {

    this.companyService.getBrands().subscribe(types => {
      if (types['data']) {
        this.brands = types['data']['cars'];
      }
    });

    this.getArticlesByNumber(this.orders).subscribe((results: any) => {
      const rest = results.articles as {Nummer: string, KorteTekst: string, brutoprijs: string}[];

      console.log(rest);

      this.articles = rest;
    });

    this.search(this.searchValue).subscribe((results: any) => {
      this.searchArticles = results.articles as {Nummer: string, KorteTekst: string, brutoprijs: string}[];
    });
  }

  public searchValue = new BehaviorSubject<ArticlesSearch>({queryString: '', skip: 0, take: 10, WSA: [], selectedGroups: []});
  public selectedFile: File = null;
  public orders: BehaviorSubject<{articleNumber: string, qty: number}[]> = new BehaviorSubject([]);

  public searchArticles: {Nummer: string, KorteTekst: string, brutoprijs: string}[];
  public articles: {Nummer: string, KorteTekst: string, brutoprijs: string}[];



  private static csvJSON(csv): {articleNumber: string, qty: number}[] {

    const lines = csv.split('\n');
    const result: {articleNumber: string, qty: number}[] = [];
    const headers = lines[0].split(';');

    for (let i = 1; i < lines.length; i++) {
      // tslint:disable-next-line:max-line-length
      const obj: { articleNumber: string, Matchcode: string, KorteTekst: string, Leverancier: string, VK1: string, Gewicht: string, Bestelnummer: string, Eenh: number , qty: number, brand: string, type: string } = { articleNumber: null, Matchcode: null, KorteTekst: null, Leverancier: null, VK1: null, Gewicht: null, Bestelnummer: null, Eenh: null , qty: null, brand: null, type: null  };
      const currentLine  = lines[i].match(/(".*?"|[^";]+)(?=\s*;|\s*$)/g);

      for (let j = 0; j < headers.length; j++) {
        obj[headers[j].toString()] = currentLine[j];
      }
      if (!obj.articleNumber) {
        continue;
      } else if (!obj.qty) {
        obj.qty = 1;
      }
      result.push(obj);
    }

    return result;
  }

  private search(value: Observable<ArticlesSearch>) {
    return value.pipe(
      debounceTime(200),
      filter(x => x.queryString.length > 1),
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
      switchMap(searchValue => {
        return this.articleService.getArticles(searchValue).pipe(map(x => x));
      })
    );
  }

  private getArticlesByNumber(value: Observable<{articleNumber: string, qty: number}[]>) {
    return value.pipe(
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
      filter(x => x.length > 0),
      switchMap(values => {
        return this.articleService.getArticlesFromCsv({ articleNumbers: values.map(x => x.articleNumber),
           companyId: this.userService.getCompany().id}); })
    );
  }

  public onFileChanged(event: any) {
    if (event.target && event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
    }
  }

  public getArticles() {
    if (this.selectedFile != null) {
      const reader = new FileReader();
      reader.readAsText(this.selectedFile, 'UTF-8');

      reader.onload = () => {
        if (typeof reader.result === 'string') {
          const res: any[] = QuickOrderComponent.csvJSON(reader.result);

          console.log(res);

          res.forEach(x => {
            this.addArticle(x.articleNumber, parseInt(x.qty.toString(), 10));
          });

          console.log(res);
          this.shoppingService.order.brand = {
            id: parseInt(res[0].brand.toString(), 10),
            image: null,
            name: 'Citroen',
            types: []
          };
          this.shoppingService.order.car_type = {
            id: parseInt(res[0].type.toString(), 10),
            image: null,
            name: 'Bipper',
          };

          this.fileInput.nativeElement.value = '';
        }
      };
    }
  }

  public addArticle(value: string, quantity = 1) {
    if (value.length > 1) {
      const copyValue: {articleNumber: string, qty: number}[]  = JSON.parse(JSON.stringify(this.orders.getValue()));

      if (copyValue.findIndex(x => x.articleNumber === value) === -1) {
        copyValue.push({articleNumber: value, qty: quantity});
      } else {
        copyValue.find(x => x.articleNumber === value).qty += quantity;
      }

      // UpdateSubject
      this.orders.next(copyValue);
    }
  }

  public updateSearchQuery(newValue: string) {
    const copyValue = JSON.parse(JSON.stringify(this.searchValue.getValue()));
    copyValue.queryString = newValue;

    // UpdateSubject
    this.searchValue.next({...this.searchValue.value, ...copyValue});
  }

  public deleteArticle(Nummer: any) {
    const copyValue: {articleNumber: string, qty: number}[]  = JSON.parse(JSON.stringify(this.orders.getValue()));
    copyValue.splice(copyValue.findIndex(x => x.articleNumber === Nummer), 1);
    if (copyValue.length === 0) {
      this.articles = [];
    }

    // UpdateSubject
    this.orders.next(copyValue);
  }

  public getArticleAmount(Nummer: string): number {
    return this.orders.getValue().find(x => x.articleNumber === Nummer).qty;
  }

  public addArticleAmount(Nummer: string) {
    const copyValue: {articleNumber: string, qty: number}[]  = JSON.parse(JSON.stringify(this.orders.getValue()));
    copyValue.find(x => x.articleNumber === Nummer).qty += 1;

    // UpdateSubject
    this.orders.next(copyValue);

  }

  public removeArticleAmount(Nummer: string) {
    const copyValue: {articleNumber: string, qty: number}[]  = JSON.parse(JSON.stringify(this.orders.getValue()));

    if (copyValue.find(x => x.articleNumber === Nummer).qty  > 1) {
      copyValue.find(x => x.articleNumber === Nummer).qty -= 1;

      // UpdateSubject
      this.orders.next(copyValue);
    }
  }

  public confirmOrder() {
    if (this.orders.getValue().length > 0) {
      this.shoppingService.order.shoppingBag = Object.assign(this.orders.getValue());
      this.articles = [];
      this.orders.next([]);
      this.router.navigate(['/', 'dashboard', 'place-order', 'overview', 'ordered', false], { queryParams: { from: 'bulk-order' } });
    }
  }

  getTotalPrice() {
    let amount = 0;
    if (this.articles) {
      this.articles.forEach((x: any) => {
        amount += (x.brutoprijs * this.getArticleAmount(x.Nummer));
      });
    }

    return amount.toFixed(2);
  }
}
